import { render, staticRenderFns } from "./detailPrescription.vue?vue&type=template&id=50ac6a4d&scoped=true"
import script from "./detailPrescription.vue?vue&type=script&lang=js"
export * from "./detailPrescription.vue?vue&type=script&lang=js"
import style0 from "./detailPrescription.vue?vue&type=style&index=0&id=50ac6a4d&prod&scoped=true&lang=css"
import style1 from "./detailPrescription.vue?vue&type=style&index=1&id=50ac6a4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac6a4d",
  null
  
)

export default component.exports